import {ArrowButtonParams} from "../types/release-calendar-arrow.types";

export const arrowButtons: Array<ArrowButtonParams> = [
  {
    direction: 'up',
    iconName: 'sort-asc-icon'
  },
  {
    direction: 'down',
    iconName: 'sort-desc-icon'
  }
]
